import type { Time } from '@internationalized/date'
import * as React from 'react'

export interface DateTimePickerContext {
  value: Date
  setDateValue: (date: Date) => void
  setTimeValue: (time: Time) => void
}

export const DateTimePickerContext = React.createContext<DateTimePickerContext | null>(null)

export function useDateTimePickerContext() {
  const context = React.useContext(DateTimePickerContext)
  if (!context) {
    throw new Error('useDateTimePicker must be used within <DateTimePicker>')
  }
  return context
}
